import styled from "styled-components";

export const DataItem = styled.div`
  display: flex;
  flex-direction: column;
`;
